import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statDpiDeliveredLocaleModule: LocaleModule = {
  name: "statDpiDelivered",
  messages: { en: en, it: it },
};
